export const GET_IMAGES_ACTION_REQUESTED = "GET_IMAGES_ACTION_REQUESTED";
export const GET_IMAGES_ACTION_DISPATCHER = "GET_IMAGES_ACTION_DISPATCHER";
export const GET_IMAGES_ERROR_DISPATCHER = "GET_IMAGES_ERROR_DISPATCHER";
export const GET_IMAGES_LOADING = "GET_IMAGES_LOADING";

//Action Creator
export const getImagesAction = (searchKeyword) => ({
  type: GET_IMAGES_ACTION_REQUESTED,
  searchKeyword,
});

//Action Dispatcher
export const getImagesActionDispatcher = (data) => ({
  type: GET_IMAGES_ACTION_DISPATCHER,
  payload: data,
});

export const getImagesErrorDispatcher = (data) => ({
  type: GET_IMAGES_ERROR_DISPATCHER,
  payload: data,
});

export const getImagesLoading = (loading) => ({
  type: GET_IMAGES_LOADING,
  payload: loading,
});